export const getErrorMessage = (error) => {
  if (error instanceof Error && error.message) return error.message;
  if (typeof error === "string") return error;

  return "Unknown browser error";
};

export const buildNearbyErrorMessage = ({ action, error }) =>
  `${action} failed. ${getErrorMessage(error)}`;
